import React from 'react';
import {useStateValue} from './state';

import {getConnectionDetails} from './connect';


const ConnectWidget = () => {

    // export const TablesMenu = () => {

    const [connection, dispatch] = useStateValue();


    const connections = getConnectionDetails('all');

    const connectionList = connections.map((value) => {
        return Object.keys(value)[0];
    });

    // dispatch({type:'connect', target:'localhost:8000'});

    function UpdateConnectionButton(target) {

        const request = {
            type:'connect',
            target: target.target
        };

        let buttonClass = 'btnDefault';

        if(connection.connection === target.target) {
            buttonClass = 'btnSelected';
        }


        return(<button type="button"
                       onClick={() => dispatch(request)}
                       className={buttonClass}
                       key={target.target}> <b>{target.target}</b>
        </button>);

    }

    return(
        <div >
            <table className="ConnectWidget-table" >
                <thead></thead>
                <tbody>
                <tr>

                    <td>Connections: </td>

                    {connectionList.map((item) => {
                        return (<td key={item}>
                                    <UpdateConnectionButton target={item}  key={item} />
                                </td>)
                    })
                }
                </tr>
                </tbody>
            </table>

        </div>
    );

}

export default ConnectWidget;

